import { BaseEdge, EdgeProps, getSimpleBezierPath } from 'reactflow'

const EDGE_HANDLE_OFFSET = 4

export function CustomEdge(props: EdgeProps) {
  const { sourceX, sourceY, targetX, targetY, targetPosition, sourcePosition } =
    props

  const [path] = getSimpleBezierPath({
    sourcePosition,
    targetPosition,

    sourceX: sourceX + EDGE_HANDLE_OFFSET,
    targetX: targetX - EDGE_HANDLE_OFFSET,

    sourceY,
    targetY,
  })

  return <BaseEdge path={path} {...props} />
}
